<button aaNoDblClick class="btn primary block">
  {{title}}
  @if (isLoading) {
    <output class="animate-spin icon-spin1"></output>
  }
</button>
